import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import MatchDashboardMenu from "./MatchDashboardMenu";
import AnimatedPageContainer from "../../../assets/containers/AnimatedPageContainer";
import MathUserSection from "./userSection";
import SplashScreen from "../SplashScreen";
import QuizRequests from "../../../assets/services/quiz";
import FinalizeReport from "../alertContents/FinalizeReport";
import SurveyAlert from "../alertContents/SurveyAlert";
import CustomHint from "../../../assets/containers/CustomHint";
// import MatchMessage from "./MatchDashboardMenu/Message";
import { useNavigate } from "react-router-dom";

export default function MatchMainPage() {
  const [showSplash, setShowSplash] = useState(true);
  const [showSurvay, setShowSurvay] = useState(false);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowSplash(false);
    }, 3000);

    return () => {
      setShowSplash(true);
      clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    dispatch(QuizRequests.getMatchId());
  }, []);

  return (
    <>
      {showSplash ? (
        <SplashScreen />
      ) : (
        <AnimatedPageContainer>
          <div className="customContainer">
            {/* <MatchMessage  /> */}
            <MathUserSection />
            {/* Message box */}
            {/* <div onClick={() => navigate("/forms")}>
              <CustomHint
                hint={"جهت ثبت نام کتاب 12 «بازی بزرگ» کلیک کنید."}
              />
            </div> */}
            <MatchDashboardMenu />
            <FinalizeReport showSurvay={() => setShowSurvay(true)} />
            <SurveyAlert
              show={showSurvay}
              handleClose={() => setShowSurvay(false)}
            />
          </div>
        </AnimatedPageContainer>
      )}
    </>
  );
}
